import { PDFDocument, PDFForm, StandardFonts, TextAlignment, setFontAndSize, PDFFont } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import { getPathCourseResource, getBinaryContent } from '../utils/electronFunctions';
import * as download from 'downloadjs/download';

const base64ToArrayBuffer = (base64String) => {
    const base64 = base64String.indexOf(";base64,") != -1 ? base64String.split(";base64,")[1] : base64String
    var binaryString = atob(base64);
    var bytes = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
} 

export default async(objText, arObjImage, pdfDocumentPath, additionalFonts) => {
    const fileBytes = await getBinaryContent(pdfDocumentPath);
    const blob = new Blob([fileBytes], {
        type: 'application/pdf',
      });
    const pdfDoc = await PDFDocument.load(await blob.arrayBuffer());
    const arFonts = [];
    if (additionalFonts && Array.isArray(additionalFonts)){
        pdfDoc.registerFontkit(fontkit);
        for (let i = 0; i < additionalFonts.length; i++){
            const fontBinary = await getBinaryContent(additionalFonts[i].font);

            const blob2 = new Blob([fontBinary], {
                type: 'application/octet-stream',
              });
            arFonts.push({
                name: additionalFonts[i].name,
                font: await pdfDoc.embedFont(await blob2.arrayBuffer())
            })
        }
    }
    
    const form = pdfDoc.getForm();
    Object.entries(objText).forEach(([key, value]) => {
        let textField = form.getTextField(key);
        textField.setText(value.value);
        if (value.textAlign){
            textField.setAlignment(TextAlignment[value.textAlign]);
        }

        if (value.fontSize){
            textField.setFontSize(value.fontSize);
        }
        if (value.fontFamily){
            const fontTTF = arFonts.filter(ele => ele.name == value.fontFamily);
            if (fontTTF.length > 0){
                textField.updateAppearances(fontTTF[0].font)
            }
        }
    });
    for (let i = 0; i < arObjImage.length; i++) {
        let textFieldImage = form.getTextField(arObjImage[i].textField);
        let embedImage = null;
        if (arObjImage[i].type == "png") {
            embedImage = await pdfDoc.embedPng(base64ToArrayBuffer(arObjImage[i].image));
        }else{
            embedImage = await pdfDoc.embedJpg(base64ToArrayBuffer(arObjImage[i].image));
        }
        if (arObjImage[i].textAlign){
            textFieldImage.setAlignment(TextAlignment[arObjImage[i].textAlign]);
         }
        textFieldImage.setImage(embedImage);
        
    }
    const pdfBytes = await pdfDoc.save();
    const filenameParts = pdfDocumentPath.split("/");
    const filename = filenameParts[filenameParts.length - 1];
    download(pdfBytes, filename, "application/pdf");
}

/**
 * Valida que un PDF contenga ciertos campos de formulario.
 * @param {File} file - El archivo PDF subido por el usuario.
 * @param {string[]} requiredFields - Lista de nombres de campos que deben existir (por ejemplo: ["nombre", "identificacion", "dia", "mes", "ano"]).
 * @returns {Promise<{valid: boolean, missing?: string[], message: string}>}
 */
export async function validatePdfFormFields(file, requiredFields = []) {
    try {
      // Leer contenido binario
      const arrayBuffer = await file.arrayBuffer();
      const pdfDoc = await PDFDocument.load(arrayBuffer);
  
      // Obtener formulario si existe
      const form = pdfDoc.getForm();
  
      if (!form) {
        return {
          valid: false,
          message: "El PDF no contiene un formulario.",
        };
      }
  
      // Obtener todos los nombres de campos del PDF
      const fields = form.getFields();
      const fieldNames = fields.map((f) => f.getName());
  
      // Verificar si todos los campos requeridos están presentes
      const missing = requiredFields.filter((name) => !fieldNames.includes(name));
  
      if (missing.length > 0) {
        return {
          valid: false,
          missing,
          message: `Faltan los campos obligatorios: ${missing.join(", ")}`,
        };
      }
  
      return {
        valid: true,
        message: "El PDF contiene todos los campos requeridos.",
      };
    } catch (err) {
      console.error("Error al validar campos del PDF:", err);
      return {
        valid: false,
        message: "El archivo no es un PDF válido o no se pudo leer.",
      };
    }
  }